import useNavigationStore from "@src/stores/navigationStore";
import USPerson from "./USPerson";
import HomeAddress from "./HomeAddress";
import FiscalAddress from "./FiscalAddress";
import Birth from "./Birth";
import LegalCapacity from "./LegalCapacity";
import Nationality from "./Nationality";
import LegalAgentSituation from "./LegalAgentSituation";
import FinancialJob from "./FinancialJob";

const componentMap = {
    USPerson: USPerson,
    LegalAgentSituation: LegalAgentSituation,
    FinancialJob: FinancialJob,
    HomeAddress: HomeAddress,
    FiscalAddress: FiscalAddress,
    Birth: Birth,
    LegalCapacity: LegalCapacity,
    Nationality: Nationality,
};

export default function SecondSection() {
    const { section } = useNavigationStore();

    const SelectedComponent = componentMap[section.block as keyof typeof componentMap] || null;

    return <>{SelectedComponent ? <SelectedComponent /> : null}</>;
}
